import BaseModel from '../BaseModel';
import ReferenceTermHighlights from '../ReferenceTermHighlights';

export default class OffsetPagingConnection extends BaseModel {
  constructor(modelType, data = {}) {
    super(OffsetPagingConnection, data);
    this.nodes = data.nodes?.map((node) => new modelType(node));
    this.offset = data.offset;
    this.limit = data.limit;
    this.totalCount = data.totalCount;
    this.hasNextPage = data.hasNextPage;
    this.highlights = data.highlights?.map(
      (highlight) => new ReferenceTermHighlights(highlight)
    );
  }
}
